import { IAPIPrompt, IAPIFolder } from 'extra/types/ApiModels'

interface PromptPageHeaderProps {
  prompt: IAPIPrompt
  currentFolder: IAPIFolder | null | undefined
}

export function PromptPageHeader ({ prompt, currentFolder }: PromptPageHeaderProps) {
  return (
    <div className="mb-4">
      <div className="flex items-baseline gap-2">
        {currentFolder && (
          <>
            <span
              className="text-lg text-gray-300 cursor-default"
              title={`Folder: ${currentFolder.name}`}
            >
              {currentFolder.name}
            </span>
            <span className="text-sm text-gray-200">›</span>
          </>
        )}
        <h1
          className="text-lg font-semibold text-white cursor-default"
          title={`Prompt: ${prompt.name}`}
        >
          {prompt.name}
        </h1>
      </div>
      {prompt.description && (
        <p
          className="text-sm text-gray-400 mt-1 cursor-default"
          title={prompt.description}
        >
          {prompt.description}
        </p>
      )}
    </div>
  )
}
